import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import Secene from '../pages/Scene/Home_New'
import Navbar from '../pages/Navbar/index/Index'
import Tools from '../pages/Tools/Index/Index'
import AppInfo from '../components/AppInfo'

const MainLayout = ({ children }) => (
    <React.Fragment>
        <Container fluid className="d-flex flex-column">
            <Row className="vh-100">
                <Col sm="3" className="h-100 p-0" style={{ zIndex: 1 }}>
                    {/* <AppInfo />  */}
                    <Tools />
                </Col>
                <Col sm="9" className="h-100 p-0">
                    <Navbar />
                    <Secene />
                </Col>
            </Row>
        </Container>
    </React.Fragment>
)

export default MainLayout
